<form [formGroup]="patientSearchForm">
    <mat-progress-bar class="progress-margin"
                      color="primary"
                      *ngIf="loading"
                      mode="indeterminate">
    </mat-progress-bar>
    <mat-form-field class="margin-right-small">
      <input type="text" matInput placeholder="Nombre" formControlName="firstName">
    </mat-form-field>
    <mat-form-field class="margin-right-small">
      <input type="text" matInput placeholder="Apellido" formControlName="lastName">
    </mat-form-field>
    <mat-form-field class="margin-right-small">
      <input type="number" matInput placeholder="Documento" #document formControlName="document">
    </mat-form-field>
    <button (click)="searchPatient()" mat-icon-button>
      <mat-icon>search</mat-icon>
    </button>
</form>
